import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroBanner from './components/HeroBanner';
import CategoryEntry from './components/CategoryEntry';
import HotList from './components/HotList';
import RecommendList from './components/RecommendList';
import CtaSection from './components/CtaSection';

export default function Home() {
  useEffect(() => {
    document.title = '星星动漫网 - 韩漫日漫国漫漫画大全 | 好看的漫画全集免费在线阅读';
  }, []);

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '星星动漫网',
    url: 'https://www.xingxingdongman.com/',
    description: '星星动漫网漫画大全，汇集韩漫、日漫、国漫等各类好看的漫画，免费全集在线观看。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.xingxingdongman.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '星星动漫网 - 首页',
    url: 'https://www.xingxingdongman.com/',
    description: '星星动漫网漫画大全，汇集韩漫、日漫、国漫等各类好看的漫画，免费全集在线观看。',
    isPartOf: {
      '@type': 'WebSite',
      name: '星星动漫网',
      url: 'https://www.xingxingdongman.com/',
    },
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(webpageSchema) }} />

      <Navbar />

      <main>
        <HeroBanner />
        <CategoryEntry />
        <HotList />
        <RecommendList />
        <CtaSection />
      </main>

      <Footer />
    </>
  );
}